import React from 'react'
import { Grid } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import CountUp from 'react-countup';
class ThreeBlockDivision extends React.Component {

    goToPage(e, pageType, pageName) {
        dispatch.home.redirectFromEventStream(true)
        const history = this.props.history;
        let urlPath = ""
        if (pageType === 'playbook') {
            if (pageName === 'In Design') {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/In Design'
            } else if (pageName === 'Approved') {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/Approved'
            } else if (pageName === 'Published') {
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/knowledgeBank'
            } else if (pageName === 'Purchased') {
                // urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/'
            }

            history.push({
                pathname: urlPath
            });
        }

        else if (pageType === 'community') {
            dispatch.home.redirectFromEventStream(true)
            dispatch.app.showToolbar(true)
            if (pageName === "Teams") {
                dispatch.community.addMainAreaContext('ORGANIZATION');
                dispatch.community.setAddUserContextData('Teams');
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_cm/team/' + this.props.selectedOrganisation.id
            } else if (pageName === "Users") {
                dispatch.invite.storeUserRole("users");
                dispatch.community.setAddUserContextData('Users');
                dispatch.community.addMainAreaContext('USERS');
                dispatch.users.userTreeSelectedPath("0")
                urlPath = urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_cm/userList/' + this.props.selectedOrganisation.id + '/users'
            } else if (pageName === 'Invitations') {
                dispatch.invite.storeUserRole("Invitations");
                dispatch.community.addMainAreaContext('USERS');
                dispatch.community.setAddUserContextData('Users');
                dispatch.users.userTreeSelectedPath("1")
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_cm/userList/' + this.props.selectedOrganisation.id + '/Invitations'
            }

            history.push({
                pathname: urlPath
            });
        }
    }


    render() {

        return (
            <Grid columns="equal" celled='internally' className="count-block-item setHoverEffect" >
                <Grid.Row>
                    <Grid.Column onClick={(e) => this.goToPage(e, this.props.type, this.props.label1Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label1Count} duration={5} /> :
                            <span>{this.props.label1Count}</span>
                        }
                        <label>{this.props.label1Name}</label>
                    </Grid.Column>
                    <Grid.Column className={`${this.props.label2Name === 'Active' ? "bdr_btm_none" : ''}`} onClick={(e) => this.goToPage(e, this.props.type, this.props.label2Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label2Count} duration={5} /> :
                            <span>{this.props.label2Count}</span>
                        }
                        <label>{this.props.label2Name}</label>
                    </Grid.Column>
                    <Grid.Column onClick={(e) => this.goToPage(e, this.props.type, this.props.label3Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label3Count} duration={5} /> :
                            <span>{this.props.label3Count}</span>
                        }
                        <label>{this.props.label3Name}</label>
                    </Grid.Column>
                </Grid.Row>

            </Grid >
        )
    }
}


export default withRouter(ThreeBlockDivision);